module.exports = __webpack_public_path__ + "static/media/bg-image.0b505043.jpg";